import React from 'react';
import UI from '../ui';

const { WrappedInputText } = UI;

// TODO: Please add logging to onChange functions for both to and from address. Please DO NOT include the entire address in the logging value due to CCPA values. We only want to to log the FromZIP, ToCountry, and ToPostalCode (which would be ZIP for domestic and PostalCode for int’l).

export const ShippingInputs = ({ shipFrom = '', shipTo = '' }) => {
	const readOnly = true;

	return (
		<div className="common-rate-advisor-shipping-inputs">
			<div className="input-container">
				<WrappedInputText
					className="rate-advisor-header-input ship-from-input"
					value={shipFrom}
					readOnly={readOnly}
					placeholder="From"
					dataqa="rate-advisor-shipfrom"
				/>
			</div>
			<span className="arrow-icon" />
			<div className="input-container">
				<WrappedInputText
					className="rate-advisor-header-input ship-to-input"
					value={shipTo}
					readOnly={readOnly}
					placeholder="To"
					dataqa="rate-advisor-shipto"
				/>
			</div>
		</div>
	);
};

export default ShippingInputs;
